import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;
`;

const Label = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #999;
    width: 30px;
`;

const Button = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    border: 1px solid #999;
    background-color: transparent;
    position: relative;
    color: #fff;
    font-size: 12px;
    cursor: pointer;

    &:before {
        content: '';
        position: absolute;
        content: '\\F0140';
        font-family: 'Material Design Icons';
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
`;

const SubtractButton = styled(Button)`
    &:before {
        content: '\\F0374';
    }
`;

const AddButton = styled(Button)`
    &:before {
        content: '\\F0415';
    }
`;

export default ({onChange, value, max, min}) => {
    const [managedValue, setManagedValue] = useState(value ?? 0);

    useEffect(() => {
        setManagedValue(value)
    }, [value]);

    const add = () => {
        if (managedValue < max) {
            setManagedValue(s => s+1);
            onChange(managedValue + 1);
        }
    }

    const sub = () => {
        if (managedValue > min) {
            setManagedValue(s => s-1);
            onChange(managedValue - 1);
        }
    }

    return <Container>
        <SubtractButton onClick={() => {sub()}} />
        <Label>{managedValue}</Label>
        <AddButton onClick={() => {add()}} />
    </Container>
}